import { Pipe, PipeTransform } from '@angular/core';

import { Logger } from '@utils/logger';

@Pipe({ name: 'truncateText' })
export class TruncateTextPipe implements PipeTransform {
  public transform(item: string, size: number): string {
    if (item) {
      const str: string = item.toString();
      if (str.length <= size) {
        return str;
      }
      return str.substring(0, size) + '...';
    }
  }
}
